module.exports = __webpack_public_path__ + "img/hemingway.85097ca4.jpg";